import gql from "graphql-tag";

const GET_TEST_RESULT = gql`
  query getTestResult($token: String!, $dob: String!) {
    testResult(token: $token, dob: $dob)
      @rest(
        type: "getTestResult"
        path: "/appointment/result/{args.token}/{args.dob}"
        endpoint: "v1"
      ) {
      result
      status
      lab_report_url
      patient_name
      patient_dob
    }
  }
`;

export { GET_TEST_RESULT };
